/**
 * Needs to correspond with breakpoints in _variables.scss in frontend folder
 */
 export default {
  'bp-x-small': 338,
  'bp-small': 579,
  'bp-medium': 768,
  'bp-large': 992,
  'bp-x-large': 1200,
};
